import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-section-what-we-do1',
    templateUrl: './section-what-we-do1.component.html',
    styleUrls: ['./section-what-we-do1.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionWhatWeDo1Component implements OnInit {

  @Input() data: any;
  @Input() sectional: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
